<%= form_with(model: song, class: "contents") do |form| %>
  <% if song.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(song.errors.count, "error") %> prohibited this song from being saved:</h2>

      <ul class="list-disc ml-6">
        <% song.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :dance_id %>
    <%= form.text_field :dance_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": song.errors[:dance_id].none?, "border-red-400 focus:outline-red-600": song.errors[:dance_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :title %>
    <%= form.text_field :title, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": song.errors[:title].none?, "border-red-400 focus:outline-red-600": song.errors[:title].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :artist %>
    <%= form.text_field :artist, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": song.errors[:artist].none?, "border-red-400 focus:outline-red-600": song.errors[:artist].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :order %>
    <%= form.number_field :order, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": song.errors[:order].none?, "border-red-400 focus:outline-red-600": song.errors[:order].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
